module.exports = __webpack_public_path__ + "img/insta_1.1cb7fed8.jpg";